import { createAction, props } from '@ngrx/store';

export enum ComplicationNameSearchActionTypes {
	NewSearchRequested = '[Complication Name Search Modal] New Search Requested',
	NewSearchSucceeded = '[Complication Name Search Effect] New Search Succeeded',
	NewSearchFailed = '[Complication Name Search Effect] New Search Failed',
	AppendResultsRequested = '[Complication Name Search Modal] Append Results Requested',
	AppendResultsSucceeded = '[Complication Name Search Effect] Append Results Succeeded',
	AppendResultsFailed = '[Complication Name Search Effect] Append Results Failed',
	ResultsCleared = '[Complication Name Search Modal] Results Cleared',
	SelectionFinished = '[Complication Name Search Effect] Selection Finished'
}

export const newSearchRequested = createAction(
	ComplicationNameSearchActionTypes.NewSearchRequested,
	props<{ queryTerm: string }>()
)

export const newSearchSucceeded = createAction(
	ComplicationNameSearchActionTypes.NewSearchSucceeded,
	props<{ searchResults: string[] }>()
)

export const newSearchFailed = createAction(
	ComplicationNameSearchActionTypes.NewSearchFailed,
	props<{ statusCode: number }>()
)

export const appendResultsRequested = createAction(
	ComplicationNameSearchActionTypes.AppendResultsRequested
)

export const appendResultsSucceeded = createAction(
	ComplicationNameSearchActionTypes.AppendResultsSucceeded,
	props<{ searchResults: string[] }>()
)

export const appendResultsFailed = createAction(
	ComplicationNameSearchActionTypes.AppendResultsFailed,
	props<{ statusCode: number }>()
)

export const resultsCleared = createAction(
	ComplicationNameSearchActionTypes.ResultsCleared
)

export const selectionFinished = createAction(
	ComplicationNameSearchActionTypes.SelectionFinished
)